import { Component, Prop, getAssetPath, h } from '@stencil/core';

import { formatCurrency } from '../../../utils/utils.currency';

const IMAGE_MONEY_CAR = 'assets/moneycar.png';

@Component({
  tag: 'tax-savings',
  styleUrl: 'tax-savings.css',
  assetsDirs: ['assets'],
})
export class TaxSavings {
  @Prop() potentialTaxSaving: number = 0;

  render() {
    return (
      <div class="container mx-auto flex-col pt-4 w-full pb-14 font-montserrat">
        <div class="flex not-italic mb-2">
          <div>
            <img alt="moneycar" src={getAssetPath(IMAGE_MONEY_CAR)} class=" md:w-full lg:w-full mr-2" />
          </div>
          <div class="font-bold tracking-tight lg:tracking-tighter">
            <div class="text-base md:text-lg lg:text-lg md:mr-16 lg:mr-16 lg:mt-1">Enjoy tax savings on your next car thanks to Instant Cash Offer!*</div>
            <div class="text-xs lg:text-sm">
              You could lower your state sales tax payment on your next car by redeeming your offer & purchasing your next car at the same dealership.
            </div>
          </div>
        </div>
        <div class="flex not-italic mb-2">
          <div class="flex-auto w-44 lg:w-80 p-0 lg:pt-0 lg:px-3 lg:pb-3 text-center">
            <div class="font-normal lg:font-semibold text-xs lg:text-sm tracking-tight pb-7 md:pb-0 lg:pb-0 break-words ml-8 md:ml-8 lg:ml-0 mr-8 md:mr-8 lg:mr-0">
              Your Potential State Tax Savings
            </div>
            <div class="text-4xl lg:text-5xl p-0 md:pt-2 lg:pt-4 w-44 lg:w-56 text-clrs-dark-green font-bold tracking-wider">{formatCurrency(this.potentialTaxSaving)}</div>
          </div>
          <div class="flex-auto font-normal lg:font-semibold text-xs lg:text-sm pt-0 lg:pt-0 lg:pl-1 lg:pb-0 tracking-tight">
            How Savings are Calculated:<br></br>
            <br></br>Simply buy your next vehicle at the same dealership where you redeem your Offer.* It’s that easy. For example, if you purchase a vehicle for $25,000 and your
            Instant Cash Offer trade-in is worth $10,000, you'd only have to pay state sales tax on $15,000. It’s the smart way to keep some extra cash in your pocket.
          </div>
        </div>
        <div class="text-caption lg:text-xs tracking-tight lg:tracking-tighter italic font-normal px-4">
          *Not available in all states. Check with dealer for eligibility. Not a guarantee of actual tax savings. Tax amounts and payments based ONLY on state sales tax rates in
          your state and excludes city, county or municipality sales tax amounts. Savings on sales tax are dependent on state laws, owner status and state of registration.
        </div>
      </div>
    );
  }
}
